export default __webpack_public_path__ + "static/media/map.ddb0ceeb.svg";